import { TextsType } from "@smartsuite/react-ui/lib/components/widgets/DatePicker/DueDateCalendarView";
import { defineMessages } from "react-intl";

import { $t } from "../../../utils/intl";

export const dueDateTexts = defineMessages({
  startTitle: {
    defaultMessage: "Start Date",
    id: "QirE3M",
  },
  startLabel: {
    defaultMessage: "Add Start Date",
    id: "uhnnlE",
  },
  cancelText: {
    defaultMessage: "Cancel",
    id: "47FYwb",
  },
  doneText: {
    defaultMessage: "Done",
    id: "JXdbo8",
  },
  endTitle: {
    defaultMessage: "End Date",
    id: "T4GOiX",
  },
  endLabel: {
    defaultMessage: "Add End Date",
    id: "vqBBHt",
  },
  timePlaceholder: {
    defaultMessage: "Add Time",
    id: "s2gfPU",
  },
});

export const texts: TextsType = {
  cancelText: $t(dueDateTexts.cancelText),
  doneText: $t(dueDateTexts.doneText),
  header: {
    startTitle: $t(dueDateTexts.startTitle),
    endTitle: $t(dueDateTexts.endTitle),
    startLabel: $t(dueDateTexts.startLabel),
    endLabel: $t(dueDateTexts.endLabel),
    timePlaceholder: $t(dueDateTexts.timePlaceholder),
  },
};
